export default {
  hero: {
    tagline: "一款基於 SwiftUI 的原生 macOS Minecraft 啟動器，提供流暢的效能、完整的模組載入器支援、Microsoft 帳戶登入和直覺的遊戲管理。",
    requirement: "需要 macOS 14.0 或更高版本",
    loading: "取得最新版本...",
    fetchError: "取得版本失敗",
    download: "下載",
    appleChip: "Apple 晶片",
    intel: "Intel",
  },
  features: {
    title: "強大功能，一目瞭然",
    subtitle: "從帳戶登入到模組管理，把複雜的操作變得簡單。",
    items: [
      {
        title: "原生 Swift，快如閃電",
        body: "基於 SwiftUI 打造，啟動迅速、介面流暢，完整支援深色模式與 macOS 系統特性，帶來真正原生的使用體驗。",
      },
      {
        title: "Microsoft 帳戶，一步登入",
        body: "安全連接 Microsoft 與 Xbox 帳戶，輕鬆管理多個角色，隨時切換，登入狀態長久保持。",
      },
      {
        title: "皮膚管理，隨心切換",
        body: "內建皮膚預覽與管理，隨時查看角色外觀，一鍵切換皮膚，所見即所得。",
      },
    ],
    moreTitle: "還有更多",
    moreCta: "還有更多功能，等你在啟動器裡親自發現。",
    moreCtaLink: "下載啟動器開始探索",
    more: [
      {
        title: "模組載入器",
        body: "Fabric、Forge、NeoForge 與 Quilt 全支援，一鍵安裝、一鍵切換。",
      },
      {
        title: "遊戲實例",
        body: "多版本、多實例獨立設定，模組與存檔互不干擾。",
      },
      {
        title: "自動更新",
        body: "基於 Sparkle 框架的自動更新，新版本發布後第一時間提示升級。",
      },
      {
        title: "原生介面",
        body: "介面完全採用 macOS 原生控制項與設計語言，自動跟隨系統深淺色外觀，與系統渾然一體。",
      },
      {
        title: "多語言",
        body: "介面支援 22 種語言，涵蓋全球主要地區。",
      },
      {
        title: "開源免費",
        body: "基於 AGPL v3 開源，程式碼透明，永久免費使用。",
      },
    ],
  },
  contributors: {
    github: "GitHub貢獻者",
    core: "核心貢獻者",
    contributions: "次貢獻",
  },
  navbar: {
    docs: "文件",
    changelog: "版本歷史",
    discussions: "討論區",
    reportIssue: "回報問題",
  },
  footer: {
    product: "產品",
    download: "下載",
    userGuide: "使用者指南",
    changelog: "版本歷史",
    community: "社群",
    discussions: "討論區",
    qqGroup: "QQ群",
    bilibili: "Bilibili",
    feedback: "回饋",
    reportIssue: "回報問題",
    legal: "協議",
    license: "AGPL v3 授權條款",
    copyright: "保留所有權利。",
    disclaimer: "Swift Craft Launcher 不隸屬於 Mojang Studios 或 Microsoft。Minecraft 是 Mojang Studios 的註冊商標。",
  },
};
